import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * The topic (folder) of the chat the chat page just opened, as read from the
 * chat doc. The rail only knows a chat's topic from its 100-chat listener
 * window, so an older chat filed in a topic would otherwise open the Chats
 * panel on reload (review S5). Dependency-free, like OwnChatsRegistry, so the
 * lifted chat feature can record into it without the shell's Firebase graph.
 */
@Injectable({ providedIn: 'root' })
export class ChatFolderHintsRegistry {
  private readonly folders = new Map<string, string | null>();

  /** Fires when a hint changes, so the rail re-resolves the URL's section. */
  public readonly changes$ = new Subject<void>();

  /** `folderId` null: the chat is in no topic. */
  public record(chatId: string, folderId: string | null): void {
    if (!chatId) return;
    const next = folderId || null;
    if (this.folders.has(chatId) && this.folders.get(chatId) === next) return;
    this.folders.set(chatId, next);
    this.changes$.next();
  }

  /** The recorded topic, null for "in none", undefined when the chat page never reported it. */
  public folderOf(chatId: string): string | null | undefined {
    return this.folders.has(chatId) ? this.folders.get(chatId) : undefined;
  }
}
